export default "/images/logo-light-text.png?3250bf604b08ef6aaa2fa7d3444c843d";